import {
    BrowserRouter,
    Routes,
    Route,
    useParams,
    useLocation,
    useNavigate
} from "react-router-dom";

import { lazy, Suspense, useEffect } from "react";

import { Provider, useDispatch, useSelector } from "react-redux";
import { store } from "./redux/store";

import Layout from "./components/Layout";
import BodyClass from "./components/BodyClass";
import ScrollToTop from "./pages/ScrollToTop";

import { HelmetProvider } from "react-helmet-async";

import { FETCH_LANGUAGES_REQUEST } from "./redux/type";
import { BASE_PATH } from "./components/config";
import NotFound from "./pages/NotFound";
import GTMPageTracker from "./components/GTMPageTracker";
import { ensureSagaGroups, getSagaGroupsForPath } from "./redux/routeSagas";

const lazyWithSagas = (pageImport, sagaGroups = []) => lazy(async () => {
    await ensureSagaGroups(sagaGroups);
    return pageImport();
});

const Home = lazy(() => import("./pages/Home"));
const ProductListing = lazyWithSagas(() => import("./pages/ProductListing"), ["listing"]);
const ShopDetail = lazyWithSagas(() => import("./pages/ShopDetail"), ["product"]);
const Cart = lazyWithSagas(() => import("./pages/Cart"), ["cart"]);
const Checkout = lazyWithSagas(() => import("./pages/Checkout"), ["checkout"]);
const ThankYou = lazyWithSagas(() => import("./pages/ThankYou"), ["thankYou"]);
const OrderCancelled = lazy(() => import("./pages/OrderCancelled"));
const Contact = lazyWithSagas(() => import("./pages/Contact"), ["contact"]);
const DataProtection = lazyWithSagas(() => import("./pages/DataProtection"), ["dataProtection"]);
const TermsConditions = lazyWithSagas(() => import("./pages/TermsConditions"), ["terms"]);
const GalleryCollection = lazyWithSagas(() => import("./pages/GalleryCollection"), ["gallery"]);
const OurLab = lazyWithSagas(() => import("./pages/OurLab"), ["lab"]);
const Frames = lazyWithSagas(() => import("./pages/Frames"), ["frames"]);
const Quality = lazyWithSagas(() => import("./pages/Quality"), ["quality"]);
const Signup = lazy(() => import("./pages/Signup"));
const Account = lazy(() => import("./pages/Account"));
const OrderListing = lazy(() => import("./pages/OrderListing"));
const OrderDetail = lazyWithSagas(() => import("./pages/OrderDetail"), ["orderDetail"]);
const Addresses = lazy(() => import("./pages/Addresses"));
const AddAddresses = lazy(() => import("./pages/AddAddresses"));
const VouchersListing = lazy(() => import("./pages/VouchersListing"));
const Sitemap = lazy(() => import("./pages/Sitemap"));
const WishlistPage = lazyWithSagas(() => import("./pages/WishlistPage"), ["wishlist"]);
const EditAddresses = lazy(() => import("./pages/EditAddress"));
const CreditSlipsPage = lazyWithSagas(() => import("./pages/CreditSlipsPage"), ["creditSlips"]);
const DefaultPage = lazy(() => import("./pages/DefaultPage"));
const ResetPassword = lazy(() => import("./pages/ResetPassword"));
// import ShopDetailNew from "./pages/ShopDetailNew";
const SUPPORTED_LANGUAGES = ["en", "nl", "de"];

function LanguageLayout() {
    const { lang } = useParams();

    if (!SUPPORTED_LANGUAGES.includes(String(lang).toLowerCase())) {
        return  (
        <NotFound />
    );
    }

    return <Layout />;
}
function AppRoutes() {
    const dispatch = useDispatch();
      const navigate = useNavigate();
    
    const { languages, error, loading } = useSelector(
        (s) => s.languages
    );

    const { lang } = useParams();
    const location = useLocation();
    const isHomeRoute = /^\/(?:en|nl|de)?\/?$/i.test(location.pathname);

    const custom_pages = useSelector(
        state => state.home.common_data?.custom_pages || []
    );
    const routeActions = {
    "contact-us": "CContactPage_sync",

    "Data_Protection-Privacy_Policy":
        "CDataProtectionPage_sync",

    "terms-conditions":
        "CTermsConditionsPage_sync",

    "GettyImagesGallerycollection":
        "CGalleryCollectionPage_sync",

    "frames":
        "CFramesPage_sync",

    "quality-prints":
        "CQualityPrintsPage_sync",

    "our-lab":
        "COurLabsPage_sync",
};
    // Languages API
    useEffect(() => {
        dispatch({ type: FETCH_LANGUAGES_REQUEST });
    }, [dispatch]);
    const currentPath_data = window.location.pathname;

    // URL language handle
    useEffect(() => {
        if (!languages?.length) return;

        let cancelled = false;

        const loadRouteData = async () => {
        await ensureSagaGroups(getSagaGroupsForPath(location.pathname));
        if (cancelled) return;

        // URL mein lang nahi hai => default EN
        const pathSegments = location.pathname
            .split("/")
            .filter(Boolean);

        const langCode = pathSegments[0] || "en";

        const selectedLanguage = languages.find(
            item => item.code === langCode
        );

        let currentPath = window.location.pathname;
        const basePath = BASE_PATH;
        
        // Remove base path for comparison
        if (currentPath.startsWith(basePath)) {
          currentPath = currentPath.substring(basePath.length) || '/';
        }

        // Agar URL language API mein nahi hai
        if (!selectedLanguage) {
            
            return;
        }

        // lang code + lang id save
        // localStorage.setItem(
        //     "user_lang",
        //     selectedLanguage.code
        // );

        // localStorage.setItem(
        //     "user_lang_id",
        //     selectedLanguage.id
        // );

        // // Common Content ko selected lang_id ke saath call karo
        // dispatch({
        //     type: COMMON_CONTENT_REQUEST,
        //     payload: {
        //         lang_id: selectedLanguage.id
        //     }
        // });
        // alert(lang)
        // alert(selectedLanguage.id)
        const payload = { lang_id: selectedLanguage.id };
  
    
          dispatch({ type: 'CcommonContent_sync', payload });
          const routeName = pathSegments[1];

          if (!routeName) {
              // index route = Home
              dispatch({
                  type: "Chome_sync",
                  payload
              });

              // return;
          }
            const actionType = routeActions[routeName];

            if (actionType) {
                dispatch({
                    type: actionType,
                    payload
                });
            }
            // dispatch({ type: 'Chome_sync', payload });

            // dispatch({ type: 'CContactPage_sync', payload });
      
            // dispatch({ type: 'CDataProtectionPage_sync', payload });
        
            // dispatch({ type: 'CTermsConditionsPage_sync', payload });
          
            // dispatch({ type: 'CGalleryCollectionPage_sync', payload });
          
            // dispatch({ type: 'CFramesPage_sync', payload });
          
            // dispatch({ type: 'CQualityPrintsPage_sync', payload });
          
            // dispatch({ type: 'COurLabsPage_sync', payload });
          
            // dispatch({ type: 'Cproducts_sync', payload });
          

          const shopDetailPattern = /\.html$/;
          if (shopDetailPattern.test(currentPath)) {
            const slug = currentPath.split('/').pop().replace('.html', '');
            dispatch({ type: 'CshopDetail_sync', payload: { ...payload, slug } });
          }

        };

        loadRouteData();
        return () => {
            cancelled = true;
        };

    }, [lang, languages, dispatch,currentPath_data, location.pathname]);

    return (
        <Suspense fallback={isHomeRoute ? (
          <section className="home-banner position-relative" aria-hidden="true">
            <div className="container">
              <div className="banner-slider home-banner-placeholder" />
            </div>
          </section>
        ) : null}>
        <Routes>

          {/* Default English */}
            <Route path="/" element={<Layout />}>

                <Route index element={<Home />} />

                <Route
                    path=":categorySlug?"
                    element={<ProductListing />}
                />
                <Route
                    path="shop/:categorySlug?"
                    element={<ProductListing />}
                />
                <Route path="cart" element={<Cart />} />
                <Route path="signup" element={<Signup />} />
                <Route path="account" element={<Account />} />

                <Route
                    path="order/:orderId"
                    element={<OrderDetail />}
                />

                <Route
                    path="wishlist"
                    element={<WishlistPage />}
                />

                <Route
                    path="my-orders"
                    element={<OrderListing />}
                />

                <Route
                    path="credit-slips"
                    element={<CreditSlipsPage />}
                />

                <Route path="sitemap" element={<Sitemap />} />

                <Route
                    path="my-vouchers"
                    element={<VouchersListing />}
                />

                <Route
                    path="my-addresses"
                    element={<Addresses />}
                />

                <Route
                    path="edit-address/:addressId"
                    element={<EditAddresses />}
                />

                <Route
                    path="add-address"
                    element={<AddAddresses />}
                />

                <Route path="checkout" element={<Checkout />} />

                <Route
                    path="contact-us"
                    element={<Contact />}
                />

                <Route
                    path="Data_Protection-Privacy_Policy"
                    element={<DataProtection />}
                />

                <Route
                    path="terms-conditions"
                    element={<TermsConditions />}
                />

                <Route
                    path="GettyImagesGallerycollection"
                    element={<GalleryCollection />}
                />

                <Route path="our-lab" element={<OurLab />} />
                <Route path="frames" element={<Frames />} />
                <Route path="quality-prints" element={<Quality />} />

                <Route
                    path="reset-password"
                    element={<ResetPassword />}
                />

                <Route
                    path=":categorySlug/:slug.html"
                    element={<ShopDetail />}
                />
                {/* <Route
                    path="new/:categorySlug/:slug.html"
                    element={<ShopDetailNew />}
                /> */}
                <Route
                    path="thank-you/:orderId"
                    element={<ThankYou />}
                />

                <Route
                    path="order-cancelled"
                    element={<OrderCancelled />}
                />

                <Route
                    path="page/:slug"
                    element={<DefaultPage />}
                />

            </Route>
            {/* Language URLs */}
            <Route path="/:lang" element={<LanguageLayout />}>

                <Route index element={<Home />} />

                <Route
                    path=":categorySlug?"
                    element={<ProductListing />}
                />
                <Route
                    path="shop/:categorySlug?"
                    element={<ProductListing />}
                />
                <Route
                    path="shop"
                    element={<ProductListing />}
                />
                <Route path="cart" element={<Cart />} />
                <Route path="signup" element={<Signup />} />
                <Route path="account" element={<Account />} />

                <Route
                    path="order/:orderId"
                    element={<OrderDetail />}
                />

                <Route
                    path="wishlist"
                    element={<WishlistPage />}
                />

                <Route
                    path="my-orders"
                    element={<OrderListing />}
                />

                <Route
                    path="credit-slips"
                    element={<CreditSlipsPage />}
                />

                <Route path="sitemap" element={<Sitemap />} />

                <Route
                    path="my-vouchers"
                    element={<VouchersListing />}
                />

                <Route
                    path="my-addresses"
                    element={<Addresses />}
                />

                <Route
                    path="edit-address/:addressId"
                    element={<EditAddresses />}
                />

                <Route
                    path="add-address"
                    element={<AddAddresses />}
                />

                <Route path="checkout" element={<Checkout />} />

                <Route
                    path="contact-us"
                    element={<Contact />}
                />

                <Route
                    path="Data_Protection-Privacy_Policy"
                    element={<DataProtection />}
                />

                <Route
                    path="terms-conditions"
                    element={<TermsConditions />}
                />

                <Route
                    path="GettyImagesGallerycollection"
                    element={<GalleryCollection />}
                />

                <Route path="our-lab" element={<OurLab />} />
                <Route path="frames" element={<Frames />} />
                <Route path="quality-prints" element={<Quality />} />

                <Route
                    path="reset-password"
                    element={<ResetPassword />}
                />

                <Route
                    path=":categorySlug/:slug.html"
                    element={<ShopDetail />}
                />

                {/* <Route
                    path="new/:categorySlug/:slug.html"
                    element={<ShopDetailNew />}
                /> */}

                <Route
                    path="thank-you/:orderId"
                    element={<ThankYou />}
                />

                <Route
                    path="order-cancelled"
                    element={<OrderCancelled />}
                />

                <Route
                    path="page/:slug"
                    element={<DefaultPage />}
                />

            </Route>
            

            

        </Routes>
        </Suspense>
  );
}

function App() {
  return (
    <Provider store={store}>
      <HelmetProvider>
        <BrowserRouter basename={`${BASE_PATH}/`}>
          <BodyClass />
          <ScrollToTop />

          <AppRoutes />

        </BrowserRouter>
      </HelmetProvider>
    </Provider>
  );
}

export default App;
